import { useEffect, useState } from "react";
import { Typography, Card } from "@mui/material";
import CareerCard from "./CareerCard";
import careerData from "../Data/career.json"
import { Career } from "./CareerSectionHelpers";
import useIsMobile from "../AppHelpers";


const CareerSection = ()=> {
    const [careerList, setCareerList] = useState<Career[]>([]);
    const [showMore, setShowMore] = useState(false);
    const [numOfItems, setNumOfItems] = useState(1);
        const isMobile = useIsMobile()

    useEffect(()=>{
        setCareerList(careerData)
    },[])

    const handleShowMore = () =>{
        setShowMore(!showMore)
    }

    const getText =() =>{
        return showMore ? 'Less...' :'More...'
    }

    useEffect(()=>{
        if(showMore){
            setNumOfItems(careerList.length)
        } else{
            setNumOfItems(1)
        }
    
    },[showMore, careerList])

       const getAllowedWidth =()=>{
        return isMobile ? '100vw' : '80vw'
    }

    return (
      <Card id='career' className="CareerSection"  raised={true} sx={{backgroundColor:'#420A02', width:{getAllowedWidth}, padding:'2rem', margin:'2rem',textAlign:'left'}}>
        <Typography variant="h3" className='mb-0' align={'left'} sx={{color: '#fff'}}>Career</Typography>
        {careerList.map((career, i )=> numOfItems >= i && 
             <CareerCard career={career}></CareerCard>
        )}
        {careerList.length > 1 &&<Typography variant="h5" className='mt-2'  align={'right'} sx={{color: '#fff', marginTop:'1rem', '&:hover':{
              cursor:'pointer'
            }}} onClick={handleShowMore}>{getText()}</Typography>} 
      </Card>
    );
  }
  
  export default CareerSection;